import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiErrorDetail } from "../lib/api";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";

export const DeleteAccountDialog = ({ open, onOpenChange }) => {
  const [busy, setBusy] = useState(false);

  const doDelete = async (e) => {
    e.preventDefault(); // keep dialog open while the request runs
    setBusy(true);
    try {
      const { data } = await api.delete("/account/me");
      // Clear the client session token WITHOUT calling logout() (which flips auth state and lets
      // the still-mounted Protected route redirect to /login before we navigate). Hard-redirect to
      // the landing page so everything unmounts cleanly.
      localStorage.removeItem("si_token");
      toast.success(data.message);
      window.location.href = "/";
    } catch (err) {
      toast.error(apiErrorDetail(err));
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-sm" data-testid="delete-account-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete your account?</AlertDialogTitle>
          <AlertDialogDescription>
            This permanently deletes your account and all associated data — portfolios, watchlists, conversations,
            ISA records, lesson progress and shared research cards. Any active Premium subscription is cancelled
            first, so no further payments are taken. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm" data-testid="delete-account-cancel">Keep my account</AlertDialogCancel>
          <AlertDialogAction onClick={doDelete} disabled={busy}
            className="rounded-sm bg-loss hover:bg-loss/85 text-white" data-testid="delete-account-confirm">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Delete permanently"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
